var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "300", persistent: true },
      model: {
        value: _vm.dialogIsOpen,
        callback: function($$v) {
          _vm.dialogIsOpen = $$v
        },
        expression: "dialogIsOpen"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-box home-form-container" },
        [
          _c("h4", { staticStyle: { "text-align": "justify" } }, [
            _vm._v(
              _vm._s(_vm.$t("DeleteCassetteWarning")) +
                " " +
                _vm._s(_vm.cassetteLabel) +
                "?"
            )
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "form-buttons", staticStyle: { padding: "8px 0" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "secondary-button",
                  attrs: { ripple: false, text: "" },
                  on: { click: _vm.cancelDelete }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("No")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "main-button",
                  attrs: { ripple: false, text: "" },
                  on: { click: _vm.confirmDelete }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Yes")) + "\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b0e4620", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0e4620","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/forms/DeleteCassetteDialog.vue
// module id = null
// module chunks = 